import React from 'react';

/* Exporting the function `Mensaje` as a constant. */
export const Mensaje = (props) => {
	/* Destructuring the props object. */
	const {mensaje, horaMensaje, tipo} = props;
	/* Returning a JSX element. */
	return (
		<div className={'mensaje ' + tipo}>
			<div className={'Contenido' + tipo}>
				<div className='horaMensaje centrador'>
					<div>{horaMensaje}</div>
				</div>
				<div>{mensaje}</div>
			</div>
		</div>
	);
};
